<template>
  <div class="login-root">
    <div class="bg-shape shape-a"></div>
    <div class="bg-shape shape-b"></div>

    <el-card class="login-card">
      <div class="login-head">
        <h1>瑞米 后台管理系统</h1>
        <p>请输入管理员账号密码登录</p>
      </div>

      <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
        <el-form-item label="账号" prop="username">
          <el-input v-model.trim="form.username" placeholder="请输入账号" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model.trim="form.password" placeholder="请输入密码" show-password @keyup.enter.native="submit" />
        </el-form-item>
        <el-button
          type="primary"
          class="login-btn"
          :loading="loading"
          @click="submit"
        >
          登录后台
        </el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { adminLogin } from '../api/admin'
import { consumeAuthExpiredFlag, setToken } from '../utils/auth'

export default {
  name: 'LoginView',
  created() {
    if (consumeAuthExpiredFlag()) {
      this.$message.warning('\u4f1a\u8bdd\u5df2\u8fc7\u671f\uff0c\u8bf7\u91cd\u65b0\u767b\u5f55')
    }
  },
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '\u8bf7\u8f93\u5165\u8d26\u53f7', trigger: 'blur' }],
        password: [{ required: true, message: '\u8bf7\u8f93\u5165\u5bc6\u7801', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid || this.loading) return
        this.loading = true
        try {
          const data = await adminLogin(this.form)
          setToken(data.token)
          this.$message.success('\u767b\u5f55\u6210\u529f')
          this.$router.replace('/users')
        } catch (error) {
          this.$message.error(error.message || '\u767b\u5f55\u5931\u8d25')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-root {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(150deg, #0f2a6d 0%, #1a4bb8 48%, #2eb1de 100%);
}

.bg-shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(6px);
}

.shape-a {
  width: 420px;
  height: 420px;
  left: -120px;
  top: -120px;
  background: rgba(255, 255, 255, 0.14);
}

.shape-b {
  width: 320px;
  height: 320px;
  right: -80px;
  bottom: -60px;
  background: rgba(145, 233, 255, 0.3);
}

.login-card {
  position: relative;
  z-index: 2;
  width: 420px;
  border-radius: 18px;
  border: none;
  box-shadow: 0 18px 44px rgba(6, 16, 44, 0.28);
}

.login-head {
  margin-bottom: 18px;
}

.login-head h1 {
  margin: 0;
  font-size: 24px;
  color: #142a57;
}

.login-head p {
  margin: 8px 0 0;
  color: #6a7693;
  font-size: 13px;
}

.login-btn {
  width: 100%;
  margin-top: 8px;
  height: 42px;
  border-radius: 10px;
}
</style>
